// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-page__content[data-v-0a388ab5]{padding-top:var(--spaces-l);overflow:hidden}@media(min-width:768px){.section-page__content[data-v-0a388ab5]{padding-top:var(--padding-3xl)}}@media screen and (min-width:568px)and (orientation:landscape)and (max-height:500px)and (max-width:980px){.section-page__content[data-v-0a388ab5]{padding-top:var(--spaces-l)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
